import { render } from "./featuresItem3.vue?vue&type=template&id=92b8e5da"
import script from "./featuresItem3.vue?vue&type=script&lang=js"
export * from "./featuresItem3.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__